import { Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'group-menu',
  templateUrl: './group-menu.component.html',
  styleUrl: './group-menu.component.scss'
})
export class GroupMenuComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  showMenu = false;

  @Input() variant: 'default' | 'kpi-expanded' = 'default';

  @Output() toggleMenuEvent = new EventEmitter<{ event: MouseEvent; column: string }>();
  @Output() closeMenuEvent = new EventEmitter<void>();
  @Output() group = new EventEmitter<boolean>();
  @Output() expandAll = new EventEmitter<void>();
  @Output() collapseAll = new EventEmitter<void>();

  totalGroupsApplied = 0;
  isGrouped = false;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get count(): number {
    return this.totalGroupsApplied;
  }

  get showBadge(): boolean {
    return this.variant === 'default' || this.totalGroupsApplied > 0;
  }

  get totalGroupApplied(): number {
    return this.totalGroupsApplied;
  }

  set totalGroupApplied(value: number) {
    this.totalGroupsApplied = value;
  }

  get isGroupApplied(): boolean {
    return this.isGrouped;
  }

  toggleGrouping(grouped: boolean): void {
    this.totalGroupApplied = grouped ? 1 : 0;
    this.isGrouped = grouped;
    this.group.emit(this.isGrouped);
    this.closeMenuAfterAction();
  }

  onToggle(event: MouseEvent): void {
    this.toggleMenu(event);
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.showMenu = !this.showMenu;
    this.toggleMenuEvent.emit({ event, column: 'table' });
  }

  closeMenu(): void {
    if (!this.showMenu) return;
    this.showMenu = false;
    this.closeMenuEvent.emit();
  }

  onMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  onExpandAll(): void {
    this.expandAll.emit();
    this.closeMenuAfterAction();
  }

  onCollapseAll(): void {
    this.collapseAll.emit();
    this.closeMenuAfterAction();
  }

  private closeMenuAfterAction(): void {
    this.closeMenu();
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeMenu();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeMenu();
  }
}
